<fe-header style="z-index: 10000"></fe-header>
<main>
    <section class="section-renta container-fluid py-5 px-0">
        <div class="row align-items-center">
            <!-- Columna de texto -->
            <div class="col-lg-6 text-center text-lg-start mb-4 mb-lg-0">
                <h1 class="title ms-md-5">
                    {{ 'fe_lp_renta_flexible_title' | translate }}
                    <span class="highlight-text">
                        {{ 'fe_lp_renta_flexible_title_highlight' | translate }}
                    </span>
                </h1>
                <p class="subtitle mx-4 ms-md-5">
                    {{ 'fe_lp_renta_flexible_subtitle' | translate }}
                    <strong>{{
                        'fe_lp_renta_flexible_subtitle_strong' | translate
                    }}</strong>
                </p>
                <a
                    [routerLink]="[]"
                    fragment="sectionForm"
                    class="btn btn-warning fw-bold px-4 py-2 mt-3 ms-md-5"
                >
                    {{ 'fe_lp_renta_flexible_cta_join' | translate }}
                </a>
            </div>

            <!-- Columna de imagen -->
            <div class="col-lg-6 text-center">
                <img
                    [src]="imageSrc | cdn"
                    alt="Img principal"
                    class="img-fluid mockup-img w-100"
                    ß
                />
            </div>
        </div>
    </section>

    <section class="section-beneficio text-center text-lg-center py-4">
        <p class="benefit-text fw-bold">
            {{ 'fe_lp_renta_flexible_benefit_intro' | translate }}
            <span class="highlight-box">
                {{ 'fe_lp_renta_flexible_benefit_highlight_1' | translate }}
            </span>
            {{ 'fe_lp_renta_flexible_benefit_middle' | translate }}
            <span class="highlight-box second-line">
                {{ 'fe_lp_renta_flexible_benefit_highlight_2' | translate }}
            </span>
        </p>
    </section>

    <section class="section-plan py-4 px-3 px-lg-0">
        <div
            class="plan-box d-flex align-items-center justify-content-between rounded-3 mx-auto"
        >
            <div
                class="d-flex flex-column flex-md-row align-items-start align-items-md-center"
            >
                <img
                    [src]="'images/carro-azul.png' | cdn"
                    alt="Carro azul"
                    class="car-icon me-5 ms-3"
                />
                <p class="plan-text mb-0 ms-md-5 mx-4">
                    {{ 'fe_lp_renta_flexible_plan_text_start' | translate }}
                    <strong>{{
                        'fe_lp_renta_flexible_plan_text_highlight' | translate
                    }}</strong
                    >,
                    {{ 'fe_lp_renta_flexible_plan_text_end' | translate }}
                </p>
            </div>
        </div>
    </section>

    <div class="d-flex justify-content-center">
        <a
            [routerLink]="[]"
            fragment="sectionForm"
            class="btn btn-unete fw-bold px-4 py-2 mt-3"
        >
            {{ 'fe_lp_renta_flexible_cta_join' | translate }}
        </a>
    </div>

    <section class="section-beneficios container-xl py-5">
        <h2 class="text-center mb-5 beneficios-title">
            <span class="highlight-text">
                {{ 'fe_lp_renta_flexible_benefits_title_1' | translate }}
            </span>
            <span class="highlight-box">
                {{ 'fe_lp_renta_flexible_benefits_title_2' | translate }}
            </span>
        </h2>

        <div class="row gy-4">
            <div
                class="col-12 col-md-6 col-lg-4"
                *ngFor="let beneficio of beneficios"
            >
                <div
                    class="beneficio-item d-flex flex-column align-items-start text-start"
                >
                    <div class="icon-box mb-3">
                        <img
                            [src]="beneficio.icono | cdn"
                            [attr.alt]="beneficio.titulo"
                        />
                    </div>
                    <h3
                        class="beneficio-titulo"
                        [innerHTML]="beneficio.titulo | translate"
                    ></h3>
                    <p class="beneficio-texto">
                        {{ beneficio.descripcion | translate }}
                    </p>
                </div>
            </div>
        </div>
    </section>

    <section
        class="section-cta-final d-flex align-items-center text-star text-md-center text-white"
    >
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-md-10 col-lg-8">
                    <h2 class="cta-text mb-4">
                        {{ 'fe_lp_renta_flexible_cta_text' | translate }}
                    </h2>
                    <a
                        [routerLink]="[]"
                        fragment="sectionForm"
                        class="btn btn-unete fw-bold px-4 py-2 mt-3"
                    >
                        {{ 'fe_lp_renta_flexible_cta_button' | translate }}
                    </a>
                </div>
            </div>
        </div>
    </section>

    <section class="renta-form py-5 enterprises" id="sectionForm">
        <div class="container">
            <div class="row align-items-center">
                <!-- Columna Izquierda: Formulario -->
                <div class="col-lg-8">
                    <h2 class="renta-form__title">
                        {{ 'fe_enterprises_form_title_1' | translate }}
                        <span>{{
                            'fe_enterprises_form_title_2' | translate
                        }}</span>
                    </h2>
                    <p class="renta-form__subtitle">
                        {{ 'fe_hbspt_form_subtitle' | translate }}
                    </p>

                    <fe-app-form-enterprises></fe-app-form-enterprises>
                </div>

                <!-- Columna Derecha: Imagen -->
                <div class="col-lg-4 text-center mt-4 mt-lg-0">
                    <img
                        [src]="'images/carro-ilustracion.svg' | cdn"
                        alt="Formulario ilustración"
                        class="img-fluid"
                    />
                </div>
            </div>
        </div>
    </section>

    <fe-blog-cards></fe-blog-cards>
</main>
<fe-footer></fe-footer>
